import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { setupErrorSanitization } from "./lib/errorSanitizer";

// Polyfill for window.webkit.messageHandlers to prevent errors in Facebook's in-app browser
// Facebook's in-app browser on iOS doesn't support webkit.messageHandlers, but some
// third-party libraries try to access it without checking if it exists first.
if (typeof window !== 'undefined') {
  if (!window.webkit) {
    (window as any).webkit = {};
  }
  if (!window.webkit.messageHandlers) {
    window.webkit.messageHandlers = {} as any;
  }
}

// Initialize Sentry for error monitoring (production only)
Sentry.init({
  dsn: "https://db7f9901ca2762d2cfcdf951de79f87f@o4510380589449216.ingest.us.sentry.io/4510380592922624",
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD, // Only enabled in production
  sendDefaultPii: false, // Don't send personal info by default
  beforeSend(event) {
    // Scrub sensitive data from error reports
    if (event.request?.headers) {
      delete event.request.headers['Authorization'];
    }
    
    // Filter out harmless webkit.messageHandlers errors from Facebook's in-app browser
    // These occur when third-party libraries try to access iOS WebKit APIs that
    // aren't available in Facebook's in-app browser context
    if (
      event.exception?.values?.[0]?.type === 'TypeError' &&
      event.exception.values[0].value?.includes('webkit.messageHandlers')
    ) {
      return null; // Don't send this error to Sentry
    }
    
    return event;
  },
});

// Sanitize console messages to hide Supabase URLs
setupErrorSanitization();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
